export const NETWORK_ONLINE = 'NETWORK_ONLINE';
export const NETWORK_OFFLINE = 'NETWORK_OFFLINE';
